import { useEffect } from "react";
import { GameIcon } from "../assets/gameIcons.js";
import { pick, useT } from "../i18n/index.js";
import { Button } from "../ui/Button.js";
import { useStore } from "../store/state.js";
import { useEvents } from "./state.js";

/** One strip above every events tab: how many rewards wait and one button that collects them all (D68, R60). */
export function RewardsStrip() {
  const t = useT();
  const claimable = useEvents((s) => s.claimable);
  const refreshClaimable = useEvents((s) => s.refreshClaimable);
  const claimAll = useEvents((s) => s.claimAll);
  const celebrate = useStore((s) => s.celebrate);
  useEffect(() => {
    void refreshClaimable();
  }, [refreshClaimable]);
  if (!claimable || claimable.count === 0) return null;
  const labels = [...new Set(claimable.items.map((i) => pick(i.label)))];
  const onClaim = async () => {
    const res = await claimAll();
    if (res && res.claimed > 0) celebrate({ key: "events.claim-all", granted: { resources: res.loot.resources, items: res.loot.items, credits: res.loot.credits }, doubled: false, vipPoints: 0, nextStep: null });
  };
  return (
    <div className="rewards-strip" data-testid="rewards-strip">
      <GameIcon id="itm.chest_gold" size={48} />
      <div className="rewards-copy">
        <strong data-testid="rewards-count">{t(claimable.count === 1 ? "events.rewards.readyOne" : "events.rewards.ready", { n: claimable.count })}</strong>
        <span className="hint ellipsis" data-testid="rewards-labels">{labels.slice(0, 3).join(" · ")}{labels.length > 3 ? " …" : ""}</span>
      </div>
      <Button variant="gold" onClick={() => void onClaim()} data-testid="rewards-claim-all">
        {t("events.rewards.claimAll")}
      </Button>
    </div>
  );
}
